<template>
  <div class="contact-us-section" id="contact-us">
    <div class="card rounded shadow contact-form">
      <div class="card-body px-md-4 py-md-4">

        <h2 v-if="title" class="font-weight-bold" :class="{ 'mb-4': subTitle == null }">{{ title }}
            <b-spinner v-if="loading" variant="success" type="grow" class="loading-spinner" label="Spinning"></b-spinner>
        </h2>

        <span v-if="subTitle" class="mt-2 mb-4" v-html="subTitle"></span>

        <b-form class="my-2" @submit="onSubmit">

          <div class="row">

            <div class="col-md-6">
              <b-form-group id="input-group-1" label="First Name:" label-for="input-1" label-class="contact-label">
                <b-form-input
                    id="input-1"
                    v-model="form.firstName"
                    placeholder="Enter your first name"
                    required>
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group id="input-group-2" label="Last Name:" label-for="input-2" label-class="contact-label">
                <b-form-input
                    id="input-2"
                    v-model="form.lastName"
                    placeholder="Enter your last name"
                    ref="lastName"
                    required>
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <b-form-group
                  id="input-group-3"
                  label="Email:"
                  label-for="input-3"
                  label-class="contact-label">
                <b-form-input
                    id="input-3"
                    v-model="form.email"
                    placeholder="Example@email.com"
                    type="email"
                    ref="email"
                    @input="validateEmail()"
                    required>
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <b-form-group id="input-group-4" label="Message:" label-for="input-4" label-class="contact-label">
                <b-form-textarea
                    id="input-4"
                    v-model="form.message"
                    placeholder="Write your message..."
                    rows="6"
                    ref="message"
                    @input="validateMessage()"
                    required>
                </b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-md-5">
              <b-button block :disabled="loading" class="submit-btn text-uppercase mt-3" pill type="submit" variant="primary">Submit Message</b-button>
            </div>

          </div>

        </b-form>

      </div>
    </div>
    <div class="color-overlay"></div>
    <div class="contact-us-space"></div>
    <div class="contact-us-bg-laptop d-none d-lg-block"></div>
    <div class="contact-us-bg d-none d-sm-block d-lg-none"></div>
    <div class="contact-us-mobile-bg d-block d-sm-none"></div>
  </div>
</template>

<script>
import { MESSAGES } from "@/module_user/uitls/messages"
export default {
  name: "ContactUs",
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        message: '',
      },
      loading: false,
    }
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    subTitle: {
      type: String,
      default: null
    },
    formType: {
      type: String,
      default: 'contact-form'
    },
    successMessage: {
      type: String,
      default: 'Form submitted successfully'
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      const form = { ...this.form, formType: this.formType };
      form.name = form.firstName + " " + form.lastName;
      this.loading = true;
      this.$store.dispatch("sendContactEmail", form)
      .then(_ => {
        console.log(form);
        this.$bvToast.toast(this.successMessage, {
          title: 'Success!',
          variant: 'success',
          autoHideDelay: 50000,
          appendToast: true,
          bodyClass: 'text-left',
          toaster: 'b-toaster-top-center'
        });
        this.rest();
      })
      .catch(_ => {
        this.$bvToast.toast('Failed to submit, try again later.', {
          title: 'Failed!',
          variant: 'danger',
          autoHideDelay: 50000,
          appendToast: true,
          bodyClass: 'text-left',
          toaster: 'b-toaster-top-center'
        });
      })
      .finally(_ => this.loading=false );
    },
    rest() {
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.email = '';
      this.form.message = '';
    },
    validateEmail(){
      const emailRegx = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,6})?$/;
      if(!emailRegx.test(this.form.email)){
        this.$refs.email.setCustomValidity(MESSAGES.ENTER_VALID_EMAIL);
      }
      else{
        this.$refs.email.setCustomValidity('');
      }
    },
    validateMessage() {
      if (this.form.message.length > 500) {
        console.log(this.form.message, this.$refs.message);
        this.$refs.message.setCustomValidity(MESSAGES.MESSAGE_LEN_EXCEEDED);
      }
      else{
        this.$refs.message.setCustomValidity('');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-spinner {
  position: absolute;
  right: 1em;
  color: #73BC44 !important;
}
span.error {
  display: block;
  color: red;
  margin-top: 5px;
}
.contact-us-section {
  position: relative;

  .contact-us-space {
    height: 20vh;
  }

  .color-overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.514);
    position: absolute;
  }

  .contact-us-bg {
    height: 90vw !important;
    background-image: url("../assets/images/contact-us-bg.png");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }
  .contact-us-bg-laptop{
    height: 50vw !important;
    background-image: url("../assets/images/contact-us-bg.png");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }
  
  .contact-us-mobile-bg {
    height: 100vh;
    background-image: url("../assets/images/mobile/contact-us-bg.png");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }

  .contact-form {
    position: absolute;
    max-width: 90%;
    width: 500px;
    top: 5%;
    left: 0;
    right: 0;
    margin: auto;
    color: #ffffff;
    background-color: #000000;
    border: none;
    z-index: 5;
    text-align: left !important;
  }

  .submit-btn {
    font-size: 14px;
    padding: 10px 20px;
    font-weight: 700;
    background-color: #73BC44;
    border: 0 !important;
  }
}
</style>
